import MGRAPI from '../interceptors/Api';

const baseUrl = '/tasks';

export const getTasks = (params, config?) => MGRAPI.get(baseUrl, { params, ...config });

export const getAllTasks = (params, config) => MGRAPI.get(`${baseUrl}/all`, { params, ...config });

export const getTask = (taskId) => MGRAPI.get(`${baseUrl}/${taskId}`);
